import { type FC, useEffect } from 'react';

import { useHelpFetcherConnected, useHelpSlice } from '../../store';
import { useCoreDispatch } from '../../store/CoreStore';
import { useHeaderSlice } from '../../store/slices/header/selectors';
import { headerActions } from '../../store/slices/header/slice';
import { HeaderModal } from '../../store/slices/header/types';
import { useIsLargerThanWide } from '../../styles/hooks/media';
import { Modal } from '../modal/modal';
import { L12nText } from '../text/L12nText';

import { HelpConnected } from './HelpConnected';
import { HelpFooter } from './HelpFooter';

export const HelpModalConnected: FC = () => {
  const helpNavHeight = useHelpSlice.getHelpNavHeight();
  const selectedHelpPage = useHeaderSlice.getCoreSelectedHelpPage();
  const openedModal = useHeaderSlice.getCoreOpenedModal();
  const isOpen = openedModal === HeaderModal.Help;

  const dispatch = useCoreDispatch();
  const isWideScreen = useIsLargerThanWide();
  const { fetchHelpFile } = useHelpFetcherConnected();

  useEffect(() => {
    if (isOpen) {
      fetchHelpFile();
    }
  }, [isOpen, fetchHelpFile]);

  const onClose = (): void => {
    dispatch(headerActions.setOpenedModal(null));
  };

  const onBack = (): void => {
    dispatch(headerActions.setSelectedHelpPage(null));
  };

  return (
    <Modal
      open={isOpen}
      large
      onClose={onClose}
      onBack={!isWideScreen && selectedHelpPage ? onBack : undefined}
      floating
      draggable
      maxBodyHeight={helpNavHeight ? helpNavHeight : undefined}
      fullScreenNoClose
      title={<L12nText tk="HELP" />}
      footer={<HelpFooter />}
    >
      <HelpConnected />
    </Modal>
  );
};
